import { Box } from '@mui/material';
import { BuilderCatalogRef } from '../../types/SimilarlySituated/BuilderCatalogRef.type';
import { BuilderCatalogFlag } from '../../types/enums/BuilderCatalogFlag.enum';

const FLAG_COLORS: Record<number, { color: string; background: string }> = {
  [BuilderCatalogFlag.AVAILABLE]: { color: '#276749', background: '#D6F5E0' },
  [BuilderCatalogFlag.PARTIAL]: { color: '#8C5511', background: '#FCEFC7' },
  [BuilderCatalogFlag.NOT_IN_DATASET]: { color: '#4A5568', background: '#E2E8F0' },
};

const UNKNOWN_FLAG = { color: '#4A5568', background: '#E2E8F0' };

interface StateBadgeProps {
  flag?: BuilderCatalogRef;
}

function StateBadge({ flag }: StateBadgeProps) {
  if (!flag) return null;
  const colors = FLAG_COLORS[flag.id] ?? UNKNOWN_FLAG;

  return (
    <Box
      sx={{
        flexShrink: 0,
        borderRadius: '5px',
        backgroundColor: colors.background,
        color: colors.color,
        fontSize: '11px',
        fontWeight: 500,
        padding: '2px 8px',
        whiteSpace: 'nowrap',
      }}
    >
      {flag.name}
    </Box>
  );
}

export default StateBadge;
